






































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { BModal, BCarousel, BSidebar } from 'bootstrap-vue';
import ReviewArea from "../../components/ReviewArea.vue";
import { Sheet, SheetField, Examinee, SheetActivity, FieldActivity, ScoreOption, ReviewText } from "../../modules/teacher/SaitenList";

const ModalImageKindEnum = Object.freeze({Scan: 1, Result: 2});

export interface Data {
  sheet_id: string
  sheet: Sheet | null
  sheetFields: SheetField[] | null
  examinees: Examinee[] | null
  isDispStudentNoCharacter: boolean
  isDispStudentName: boolean
  studentNoCharacterWidth: number
  studentNameWidth: number
  rightTableTdWidth: string
  colspan: number
  totalScoreAverage: number
  totalScoreRate: number
  totalFieldCount: number
  totalFirstSaitenCompletedCount: number
  totalSecondSaitenCompletedCount: number
  totalThirdSaitenCompletedCount: number
  delayedJobCount: number
  isSaitenCompleted: boolean
  isStudentNoSortDesc: boolean
  isTotalScoreSortDesc: boolean
  isFieldScoreSortDest: boolean
  isPdfJobProcessing: boolean
  modalExaminee: Examinee | null
  modalImageKind: number
  carouselPageIdx: number
  ModalImageKindEnum: Readonly<{Scan: number; Result: number;}>
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  windowHeight: number
  scoreOptions: ScoreOption[]
  errors: string[]
  isReviewImageVisible: boolean
  isReviewOverlay: boolean
  reviewOverlayText: string
  isScanImageVisible: boolean
  scanImageExamineeIds: number[]
  previewScanImageExamineeId: number
  isResultImageVisible: boolean
  resultImageExamineeIds: number[]
  previewResultImageExamineeId: number
  isPdfDownloadSingleFile: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "review-area": ReviewArea,
    "preview-image-sidebar": PreviewImageSidebar,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const pdfDownlaodModalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const reviewAreaRef = ref<InstanceType<typeof ReviewArea>>();
    const sidebarReviewlImageRef = ref<InstanceType<typeof BSidebar>>();
    const previewScanImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();
    const previewResultImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: null,
      sheetFields: new Array<SheetField>(),
      examinees: new Array<Examinee>(),
      isDispStudentNoCharacter: false,
      isDispStudentName: false,
      studentNoCharacterWidth: 0,
      studentNameWidth: 0,
      rightTableTdWidth: "",
      colspan: 3,
      totalScoreAverage: 0,
      totalScoreRate: 0,
      totalFieldCount: 0,
      totalFirstSaitenCompletedCount: 0,
      totalSecondSaitenCompletedCount: 0,
      totalThirdSaitenCompletedCount: 0,
      delayedJobCount: 0,
      isSaitenCompleted: false,
      isStudentNoSortDesc: false,
      isTotalScoreSortDesc: false,
      isFieldScoreSortDest: false,
      isPdfJobProcessing: false,
      modalExaminee: null,
      modalImageKind: ModalImageKindEnum.Scan,
      ModalImageKindEnum: ModalImageKindEnum,
      SheetTypeEnum: Common.SheetTypeEnum,
      carouselPageIdx: 0,
      windowHeight: 0,
      scoreOptions: new Array<ScoreOption>(),
      errors: [],
      isReviewImageVisible: false,
      isReviewOverlay: false,
      reviewOverlayText: "",
      isScanImageVisible: false,
      scanImageExamineeIds: [],
      previewScanImageExamineeId: null,
      isResultImageVisible: false,
      resultImageExamineeIds: [],
      previewResultImageExamineeId: null,
      isPdfDownloadSingleFile: false,
    });

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      state.windowHeight = windowHeight;

      if(tableArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * テーブルスクロールイベント
     ************************************************************/

    const scrollChanged = () => {
      const topRightTableArea: Element = document.getElementById("top-right-table-area");
      const bottomLeftTableArea: Element = document.getElementById("bottom-left-table-area");
      const bottomRightTableArea: Element = document.getElementById("bottom-right-table-area");

      topRightTableArea.scrollLeft = bottomRightTableArea.scrollLeft;
      bottomLeftTableArea.scrollTop = bottomRightTableArea.scrollTop;
    };

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 採点画像・エクセル出力可否判定
     ************************************************************/

    const isExcelPdfButtonEnable = computed((): boolean => {
      if(context.root.$store.getters.isEntranceOrPractice){
        return state.isSaitenCompleted && state.sheet.approval_flg;
      }else{
        return state.isSaitenCompleted;
      }
    });

    /************************************************************
     * 採点画像ボタン表示判定
     ************************************************************/

    const isPdfButtonVisible = computed((): boolean => {
      // admin権限、又は入試の場合は表示
      return context.root.$store.state.currentUser.role == Common.RoleEnum.Admin || (context.root.$store.getters.isEntranceOrPractice && context.root.$store.getters.isAdminOrTeacher1);
    });

    /************************************************************
     * 画像作成ボタン押下
     ************************************************************/

    const createPdfJob = async () => {
      if(!window.confirm("採点画像作成を実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/teacher/saiten_list/create_pdf_job/${state.sheet_id}`).then(response => {
        alert("採点画像作成を開始しました");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * Excel出力ボタン押下
     ************************************************************/

    const downloadExcel = async () => {
      if(!window.confirm("採点結果Excelファイルを出力します。よろしいですか？")){
        return;
      }

      await http.get(`/api/teacher/saiten_list/download_excel/${state.sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `採点結果_${state.sheet.name}_${state.sheet.room_name}組.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 承認ボタン押下
     ************************************************************/

    const updateApproval = async (approval_flg: boolean) => {
      const msg = approval_flg ? "この試験を承認します。よろしいですか？" : "承認を解除します。よろしいですか？";
      if(!window.confirm(msg)){
        return;
      }

      await http.post(`/api/teacher/saiten_list/update_approval/${state.sheet_id}`, {approval_flg: approval_flg}).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 出席番号列でソート
     ************************************************************/

    const sortStudentNo = () => {
      state.isStudentNoSortDesc = !state.isStudentNoSortDesc;
      if(state.isStudentNoSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.student_no - b.student_no);
      }
    }

    /************************************************************
     * 合計得点列でソート
     ************************************************************/

    const sortTotalScore = () => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.score - b.score).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.score - b.score);
      }
    };

    /************************************************************
     * 設問列でソート
     ************************************************************/

    const sortFieldScore = (idx: number) => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b)).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b));
      }
    };

    /************************************************************
     * 設問列のソートロジック 得点でソートする
     * 誤答・未採点・欠席者を区別するため
     * ダミー得点として未採点は-1、欠席者は-2でソートする
     ************************************************************/

    const sortFieldScoreSub = (idx: number, e1: Examinee, e2: Examinee) => {
      let scoreA = 0, scoreB = 0;
      if(e1.fieldActivities.length > idx){
        scoreA = e1.fieldActivities[idx].score == null ? -1 : e1.fieldActivities[idx].score;
      }else{
        scoreA = -2;
      }
      if(e2.fieldActivities.length > idx){
        scoreB = e2.fieldActivities[idx].score == null ? -1 : e2.fieldActivities[idx].score;
      }else{
        scoreB = -2;
      }
      return scoreA - scoreB;
    }

    /************************************************************
     * モーダル種別に応じた答案or採点結果画像base64を返却
     ************************************************************/

    const base64Images = computed((): string[] => {
      if(state.modalExaminee == null){
        return [];
      }else if(state.modalImageKind == state.ModalImageKindEnum.Scan){
        return state.modalExaminee.base64ScanImages;
      }else{
        return state.modalExaminee.base64ResultImages
      }
    });

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalExaminee == null){
        return "";
      }
      
      if(context.root.$store.getters.isEntranceOrPractice){
        if(state.modalImageKind == state.ModalImageKindEnum.Scan){
          return `答案画像　受験番号：${state.modalExaminee.student_no_character}`;
        }else{
          return `採点結果　受験番号：${state.modalExaminee.student_no_character}`;
        }
      }else{
        if(state.modalImageKind == state.ModalImageKindEnum.Scan){
          return `答案画像　出席番号：${state.modalExaminee.student_no}番`;
        }else{
          return `採点結果　出席番号：${state.modalExaminee.student_no}番`;
        }
      }
    });

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showModalImage = async (examinee: Examinee, imageKind: number) => {

      if((imageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
        || (imageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage(examinee, imageKind)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.modalExaminee = examinee;
      state.modalImageKind = imageKind;
      state.carouselPageIdx = 0;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async (examinee: Examinee, imageKind: number) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
      await http.get(`/api/teacher/saiten_list/download_image/${state.sheet_id}/${sheetActivityIds}/${imageKind}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          if(imageKind == state.ModalImageKindEnum.Scan){
            examinee.base64ScanImages.push(x);
          }else{
            examinee.base64ResultImages.push(x);
          }
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx - 1; i >= 0; i--){
        const examinee = state.examinees[i];
        if(!examinee.absent_flg){
          if((state.modalImageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
            || (state.modalImageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx + 1; state.examinees.length; i++){
        const examinee = state.examinees[i];
        if(!examinee.absent_flg){
          if((state.modalImageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
            || (state.modalImageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * 講評画像 or 採点結果画像表示
     ************************************************************/

    const showReviewImage = async (examinee: Examinee) => {
      await initializeReviewExaminee(examinee);
      state.modalExaminee = examinee;
      state.isReviewImageVisible = true;
    };

    /************************************************************
     * 講評画像クローズ
     ************************************************************/

    const hiddenReviewImage = () => {
      state.isReviewImageVisible = false;
    }

    /************************************************************
     * 講評モーダルの表示対象画像初期化
     ************************************************************/

    const initializeReviewExaminee = async (examinee: Examinee) => {
      
      // 採点結果画像未DLの場合はDL実行
      if(examinee.base64ResultImages.length == 0){
        
        // 採点結果画像DL
        state.isReviewOverlay = true;
        state.reviewOverlayText = "画像データ取得中... しばらくお待ちください。";
        const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
        await http.get(`/api/teacher/saiten_list/download_result_image/${state.sheet_id}/${sheetActivityIds}`).then(response => {
          response.data.base64_images.forEach((x: string) => {
            examinee.base64ResultImages.push(x);
          });

          examinee.sheetActivities.forEach(SheetActivity => {
            const reviewTexts: ReviewText[] = response.data.review_texts.filter((x: ReviewText) => x.sheet_activity_id == SheetActivity.id);
            SheetActivity.reviewTexts = reviewTexts;
            SheetActivity.idx = reviewTexts.length == 0 ? 0 : reviewTexts.map(x => x.idx).reduce((a,b)=>Math.max(a,b)) + 1;
          });
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        state.isReviewOverlay = false;
      }
    }

    /************************************************************
     * 講評モーダルの表示対象生徒切り替え
     * ReviewAreaからemitで呼ばれる
     ************************************************************/

    const changeReviewExaminee = async (examinee: Examinee, addCount: number) => {
      
      const idx = state.examinees.indexOf(examinee) + addCount;
      
      if(idx < 0 || idx >= state.examinees.length){
        return;
      }

      const newExaminee = state.examinees[idx];
      await initializeReviewExaminee(newExaminee);
      state.modalExaminee = newExaminee;
    }

    /************************************************************
     * 講評コメント更新
     ************************************************************/

    const updateReview = async (param: object) => {

      state.isReviewOverlay = true;
      context.root.$store.dispatch("showOverlay");
      state.reviewOverlayText = "処理実行中... しばらくお待ちください。";

      await http.post(`/api/teacher/saiten_list/update_review_text`, param).then(response => {
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          reviewAreaRef.value.errors = error.response.data.errors;
        }else{
          reviewAreaRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      const examieeId = state.modalExaminee.id;
      const modalExaminee = state.examinees.filter(x => x.id == examieeId);
      if(modalExaminee){
        await initializeReviewExaminee(modalExaminee[0]);
        state.modalExaminee = modalExaminee[0];
      }

      state.isReviewOverlay = false;
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * ダウンロードヘッダチェックボックス変更イベント
     ************************************************************/

    const allSelectChanged = (changedVal: boolean) => {
      state.examinees.filter(x => !x.absent_flg).forEach(x => {
        x.checked = changedVal;
      });
    };

    /************************************************************
     * ダウンロードアイコン押下
     ************************************************************/

    const downloadPdf = async () => {

      const studentIds = state.examinees.filter(x => !x.absent_flg && x.checked).map(x => x.student_no);
      if(studentIds.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      pdfDownlaodModalRef.value.hide();

      const param = {
        student_ids: studentIds
      }

      const apiName = state.isPdfDownloadSingleFile ? "download_pdf_single" : "download_pdf_multi";

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_list/${apiName}/${state.sheet_id}`, param, {responseType: 'arraybuffer'}).then(response => {
        if(state.isPdfDownloadSingleFile){
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}_${state.sheet.room_name}組.pdf`;
          a.click();
        }else{
          const blob = new Blob([response.data], { type: 'application/zip' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}.zip`;
          a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * ペンシルアイコン押下 採点画面へ遷移
     ************************************************************/

    const saitenStart = (sheetField: SheetField) => {
      if(sheetField.scoring_type == Common.ScoringTypeEnum.Seigo){
        context.root.$router.push(`/teacher_site/saiten_input/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }else if(Common.IsScoringTypeScoreStamp(sheetField.scoring_type)){
        context.root.$router.push(`/teacher_site/saiten_input_score_stamp/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }
    }

    /************************************************************
     * 配点プルダウン変更
     ************************************************************/

    const allotChanged = async (sheetField: SheetField) => {

      if(!window.confirm("配点を変更しますか？")){
        sheetField.allot = sheetField.allotCache;
        return;
      }
      const param: object = {
        sheet_field_idx: state.sheetFields.indexOf(sheetField),
        allot: sheetField.allot
      };

      await http.post(`/api/teacher/saiten_list/update_allot/${state.sheet.sheet_group_key}`, param).then(response => {
        alert("配点の変更が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/teacher/saiten_list?sheet_id=${state.sheet_id}`).then(response => {

        state.sheet = new Sheet(response.data.sheet, response.data.approved_user_name);
        state.delayedJobCount = response.data.create_pdf_job_count

        const fieldActivities: FieldActivity[] = response.data.field_activities.map((x: any) => new FieldActivity(x));
        const sheetActivities: SheetActivity[] = new Array<SheetActivity>();
        response.data.sheet_activities.forEach((x: any) => {
          sheetActivities.push(new SheetActivity(x));
        });

        response.data.examinees.forEach((x: any) => {
          state.examinees.push(new Examinee(x, sheetActivities, fieldActivities, response.data.exists_result_image_student_nos));
        });

        response.data.sheet_fields.forEach((x: any) => {
          state.sheetFields.push(new SheetField(x, fieldActivities, state.sheet));
        });

        const attendStudentExaminees = state.examinees.filter(x => !x.absent_flg);
        let totalScore = Common.sumArray(attendStudentExaminees.map(x => x.score));
        const totalAllot = state.sheet.allot * attendStudentExaminees.length;
        state.totalScoreAverage = Number((totalScore / attendStudentExaminees.length).toFixed(1));
        state.totalScoreRate = Math.round(totalScore / totalAllot * 100);
        state.totalFieldCount = state.sheetFields.length * attendStudentExaminees.length;
        state.totalFirstSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.firstSaitenCompletedCount));
        state.totalSecondSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.secondSaitenCompletedCount));
        state.totalThirdSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.thirdSaitenCompletedCount));

        if(state.sheet.verify_count == 2){
          state.isSaitenCompleted = state.totalSecondSaitenCompletedCount == state.totalFieldCount;
        }else if(state.sheet.verify_count == 3){
          state.isSaitenCompleted = state.totalThirdSaitenCompletedCount == state.totalFieldCount;
        }else{
          state.isSaitenCompleted = state.totalFirstSaitenCompletedCount == state.totalFieldCount;
        }

        state.isPdfJobProcessing = response.data.is_pdf_processing;
        state.isDispStudentNoCharacter = state.examinees.filter(x => x.student_no_character != null && x.student_no_character != "").length > 0;
        state.isDispStudentName = state.examinees.filter(x => x.student_name != null && x.student_name != "").length > 0 && !state.sheet.is_mask_student_info;
        state.colspan += state.isDispStudentNoCharacter ? 1 : 0;
        state.colspan += state.isDispStudentName ? 1 : 0;
        state.colspan += !context.root.$store.getters.isEntranceOrPractice ? 1 : 0;
        const studetnCharacterMaxLength = state.examinees.map(x => x.student_no_character == null ? 0 : x.student_no_character.length).reduce((a,b)=>Math.max(a,b));
        state.studentNoCharacterWidth = studetnCharacterMaxLength > 3 ? studetnCharacterMaxLength * 20 : 65;
        const studentNameMaxLength = state.examinees.map(x => x.student_name == null ? 0 : x.student_name.length).reduce((a,b)=>Math.max(a,b));
        state.studentNameWidth = studentNameMaxLength > 3 ? studentNameMaxLength * 20 : 65;
        
        let rightTableTdWidth = 0;

        const fieldNames: string[] = state.sheetFields.map(x => `${x.part1}${x.part2}${x.part3}`.replace("null", ""));
        let fieldNameMaxLength = fieldNames.map(x => x.length).reduce((a,b)=>Math.max(a,b));
        rightTableTdWidth = fieldNameMaxLength > 3 ? fieldNameMaxLength * 20 : 80;
        
        if(state.sheet.verify_count >= 2){
          const teacherNames: string[] = state.sheetFields.map(x => x.first_user_name).concat(state.sheetFields.map(x => x.second_user_name)).concat(state.sheetFields.map(x => x.third_user_name));
          let teacherNameMaxLength = 0;
          if(teacherNames.filter(x => x != null).length > 0){
            teacherNameMaxLength = teacherNames.filter(x => x != null).map(x => x.length).reduce((a,b)=>Math.max(a,b));
          }
          const teacherTdWidth = teacherNameMaxLength > 3 ? teacherNameMaxLength * 20 : 80;
          if(teacherTdWidth > rightTableTdWidth){
            rightTableTdWidth = teacherTdWidth;
          }
        }
        state.rightTableTdWidth = `${rightTableTdWidth}px`;

        for(let i = 1; i <= 100; i++){
          state.scoreOptions.push(new ScoreOption(i, `${i}点`));
        }

        state.scanImageExamineeIds = state.examinees.filter(x => !x.absent_flg).map(x => x.id);
        state.resultImageExamineeIds = state.examinees.filter(x => x.result_image_created).map(x => x.id);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      document.getElementById("bottom-right-table-area").onscroll = scrollChanged;
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });



    const showScanImage = (examinee: Examinee) => {
      state.previewScanImageExamineeId = examinee.id;
      state.isScanImageVisible = true;
    }

    const showResultImage = (examinee: Examinee) => {
      state.previewResultImageExamineeId = examinee.id;
      state.isResultImageVisible = true;
    }

    return {
      ...toRefs(state),
      modalRef,
      pdfDownlaodModalRef,
      carouselRef,
      sidebarReviewlImageRef,
      previewScanImageSidebarRef,
      previewResultImageSidebarRef,
      convertExecDateText,
      createPdfJob,
      downloadExcel,
      sortStudentNo,
      sortTotalScore,
      sortFieldScore,
      base64Images,
      modalTitle,
      showModalImage,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      allSelectChanged,
      downloadPdf,
      saitenStart,
      isExcelPdfButtonEnable,
      isPdfButtonVisible,
      updateApproval,
      allotChanged,
      showReviewImage,
      hiddenReviewImage,
      initializeReviewExaminee,
      changeReviewExaminee,
      updateReview,
      showScanImage,
      showResultImage,
    };
  }
})
